


















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import PHeader from './header.vue';
import PMenu from './menu.vue';
import menuList from './data/menuList';
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
@Component({
  components: { PHeader, PMenu },
})
export default class Layout extends Vue {
  // vuex
  @Getter('user/userInfo') public userInfo: any;
  @Getter('app/checkDelete') public checkDelete: any;
  @Getter('app/actionMenu') public actionMenu: any;
  @Action('user/getUserInfo') public getUserInfo: any;
  // data
  private marLeft = 1200;
  private inResize = false;
  private isCollapse = false;
  private showCreatBox = false;
  private routePath = '';

  // watch
  @Watch('$route') private watchRoute(val: any, oldVal: any) {
    if (val.meta.parentTab !== oldVal.meta.parentTab) {
      this.inResize = true;
      this.$nextTick(() => {
        this.inResize = false;
      });
    }
    // console.log(val.meta.parentTab, "val.meta.parentTab");
    // console.log(this.$route.path, "oldVal.meta.parentTab");
  }

  private toClose() {
    this.$store.dispatch('app/actionCheckDelete', false);
  }
  private closeCreatBox() {
    console.log('关闭');
    this.showCreatBox = false;
  }
  // computed
  private get siderStyle() {
    return {
      marginLeft: `-${this.marLeft / 2}px`,
    };
  }
  private get userMenu(): any[] {
    const list: any = menuList;
    // console.log("this.actionMenu", this.actionMenu);
    return list[this.actionMenu];
  }
  private beforeRouteEnter(to: any, from: any, next: any) {
    // 刷新时起作用
    next((vm: any) => {
      if (to.path === '/voting/add.html') {
        vm.isCollapse = true;
      } else {
        vm.isCollapse = false;
      }
    });
  }
  // 路由更新
  private beforeRouteUpdate(to: any, from: any, next: any) {
    // 跳转时起作用
    if (to.path === '/voting/add.html') {
      this.isCollapse = true;
    } else {
      this.isCollapse = false;
    }
    next();
  }
  // 当离开当前路由时
  private beforeRouteLeave(to: any, from: any, next: any) {
    next();
  }

  /**
   * @description: 导航菜单跳转
   * @param {*} routePath
   */
  private menuSelect(routePath: any): void {
    this.routePath = routePath;
    if (routePath === '/questionnaire/add.html') {
      this.showCreatBox = true;
    } else {
      this.$router.push({
        path: routePath,
      });
    }
    console.log(this.routePath);
  }
  // private mounted() {}
  private getCollapse() {
    // console.log("isCollapse", this.isCollapse);
    if (!this.isCollapse) {
      this.isCollapse = true;
    } else {
      this.isCollapse = false;
    }
  }
}
